export enum AiUsageDimension {
    Org = 0,
    User = 1,
    Month = 2
}
